function calculateDeliveryDate(shippingMethod) {
    const today = new Date();
    let minDays, maxDays;

    if (shippingMethod === 'Standard') {
        minDays = 12;
        maxDays = 30;
    } else if (shippingMethod === 'Express') {
        minDays = 8;
        maxDays = 16;
    } else {
        return "Invalid shipping method";
    }

    const minDeliveryDate = new Date(today);
    minDeliveryDate.setDate(today.getDate() + minDays);

    const maxDeliveryDate = new Date(today);
    maxDeliveryDate.setDate(today.getDate() + maxDays);

    // Format dates to MMM DD
    const formatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit' });
    const minDateFormatted = formatter.format(minDeliveryDate);
    const maxDateFormatted = formatter.format(maxDeliveryDate);

    return `${minDateFormatted} - ${maxDateFormatted}`;
}


const standardShipping = calculateDeliveryDate('Standard');
const expressShipping = calculateDeliveryDate('Express');

try {
  document.getElementById('order_deleverd').textContent = standardShipping;
document.getElementById('order_deleverd_1').textContent = expressShipping;
} catch (error) {
  console.log(error.message)
}



document.addEventListener("DOMContentLoaded", (event) => {
  let url = new URL(window.location.href);
  let currentUrl = `${url.origin}${url.pathname}`;
  let urlObject = new URL(url);
  
  // Get the value of the 'sort_by' parameter
  let sortBy = urlObject.searchParams.get('sort_by');
  let page = urlObject.searchParams.get('page') === null ? 1 : urlObject.searchParams.get('page');
  
  // run once
  document.querySelectorAll(".snize-main-panel-dropdown-sales_amount-desc").forEach((element) => {
      element.setAttribute("href", "javascript:void(0);");
      element.addEventListener("click", function(e) {
          sessionStorage.setItem("isBestSellingFilter", "true");
          e.preventDefault();
          window.location.replace(`${currentUrl}?tab=products&sort_by=title&page=${page}`);
      });
  });
  
  if (sortBy === 'sales_amount' || sortBy === 'created-descending') {
      if (sortBy === "sales_amount") {
          sessionStorage.setItem("isBestSellingFilter", "true");
      } else {
          sessionStorage.setItem("isNewToOld", "true");
  
      }
      window.location.replace(`${currentUrl}?tab=products&sort_by=title&page=${page}`);
      return;
  }
  
  setInterval(() => {
      if (sessionStorage.getItem("isBestSellingFilter") === "true" || sessionStorage.getItem("isNewToOld") === "true" && sortBy) {
  
          if (sessionStorage.getItem("isBestSellingFilter") === "true") {
              document.querySelector(".snize-main-panel-dropdown-button >span").textContent = "BEST SELLING"
              window.history.replaceState(null, "", `${currentUrl}?tab=products&sort_by=sales_amount&page=${page}&sort_order=desc`);
          } else {
              document.querySelector(".snize-main-panel-dropdown-button >span").textContent = "DATE: NEW TO OLD";
              window.history.replaceState(null, "", `${currentUrl}?tab=products&sort_by=created&page=${page}&sort_order=desc`);
          }
          // pagination button
          document.querySelectorAll(".snize-pagination a").forEach((element) => {
              element.addEventListener("click", function(e) {
  
                  e.preventDefault();
                  if (element.classList.contains("snize-pagination-next")) {
                      window.location.replace(`${currentUrl}?tab=products&sort_by=title&page=${Number(page)+1}`);
                  } else if (element.classList.contains("snize-pagination-prev")) {
                      window.location.replace(`${currentUrl}?tab=products&sort_by=title&page=${Number(page)-1}`);
                  } else {
                      let pageNum = Number(element.getAttribute("rev"));
                      window.location.replace(`${currentUrl}?tab=products&sort_by=title&page=${pageNum}`);
                  }
              });
  
          });
      }
  
      document.querySelectorAll(".snize-main-panel-dropdown-content>li>a").forEach((element) => {
          element.addEventListener("click", () => {
              sessionStorage.setItem("isBestSellingFilter", "false");
              sessionStorage.setItem("isNewToOld", "false");
  
  
          });
      });
      document.querySelectorAll(".snize-main-panel-dropdown-title-asc").forEach((element) => {
          element.setAttribute("href", "javascript:void(0);");
          element.addEventListener("click", function(e) {
              sessionStorage.setItem("isBestSellingFilter", "false");
              sessionStorage.setItem("isNewToOld", "false");
              e.preventDefault();
              page = 1;
              window.location.replace(`${currentUrl}?tab=products&sort_by=title&page=${page}`);
          });
      });
      document.querySelectorAll(".snize-main-panel-dropdown-sales_amount-desc").forEach((element) => {
          element.setAttribute("href", "javascript:void(0);");
          element.addEventListener("click", function(e) {
              sessionStorage.setItem("isBestSellingFilter", "true");
              e.preventDefault();
              page = 1;
              window.location.replace(`${currentUrl}?tab=products&sort_by=title&page=${page}`);
          });
      });
      document.querySelectorAll(".snize-main-panel-dropdown-created-desc").forEach((element) => {
          element.setAttribute("href", "javascript:void(0);");
          element.addEventListener("click", function(e) {
              sessionStorage.setItem("isNewToOld", "true");
              e.preventDefault();
              page = 1;
              window.location.replace(`${currentUrl}?tab=products&sort_by=title&page=${page}`);
          });
      });
  }, 500);
});